import css from 'styled-jsx/css';
import { zIndex, common } from '../../theme/theme';

const style = css.global`
  .add-category-wrapper {
    z-index: ${zIndex.allAroundModal};
  }
  .add-category-wrapper .ant-modal-header {
    padding: 15px;
    border-bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .add-category-wrapper .ant-modal-title {
    font-size: 24px;
  }
  .add-category-wrapper .ant-modal-body {
    padding: 15px;
    padding-top: 0;
  }
  .add-category-wrapper .ant-modal-close {
    width: 50px;
    height: 50px;
    color: black;
  }
  .add-category-contents {
    width: 400px;
  }
  .add-category-inputs-container {
    padding: 16px;
  }
  .submit-button-container {
    padding: 8px 16px 8px 16px;
  }
  .add-category-wrapper :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .add-category-wrapper :global(.submit-button:hover) {
    ${common.button}
    ${common.submitButton}
  }
  .error {
    color: red;
    font-size: 11px;
    margin-bottom: 0;
    margin: 4px;
  }
`;

export default style;
